import React, { useState } from 'react';

function CTA() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send to your backend
    console.log('Email submitted:', email);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setEmail('');
    }, 3000);
  };

  return (
    <section className="cta-section">
      <div className="cta-background">
        <div className="gradient-orb orb-left"></div>
        <div className="gradient-orb orb-right"></div>
      </div>

      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">
            Ready to Transform Your Enterprise with AI?
          </h2>
          <p className="cta-subtitle">
            Join hundreds of companies already using CerebralMachines to automate decisions, 
            increase efficiency, and unlock new insights.
          </p>

          <form onSubmit={handleSubmit} className="cta-form">
            <input
              type="email"
              placeholder="Enter your work email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="cta-input"
            />
            <a href="/signup" style={{flex: 1}}>
              <button type="button" className="btn-primary btn-large" style={{width: '100%'}}>
                Get Started Free
              </button>
            </a>
          </form>

          {submitted && (
            <div className="success-message">
              ✓ Thanks! We'll be in touch soon.
            </div>
          )}

          <div className="cta-features">
            <div className="cta-feature">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <circle cx="10" cy="10" r="8"/>
                <path d="M6 10 L9 13 L14 7" stroke="white" strokeWidth="2" fill="none"/>
              </svg>
              <span>Free 30-day trial</span>
            </div>
            <div className="cta-feature">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <circle cx="10" cy="10" r="8"/>
                <path d="M6 10 L9 13 L14 7" stroke="white" strokeWidth="2" fill="none"/>
              </svg>
              <span>No credit card required</span>
            </div>
            <div className="cta-feature">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <circle cx="10" cy="10" r="8"/>
                <path d="M6 10 L9 13 L14 7" stroke="white" strokeWidth="2" fill="none"/>
              </svg>
              <span>Cancel anytime</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTA;

